export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden" aria-label="网站介绍">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20artistic%20illustration%2C%20vibrant%20warm%20color%20palette%20with%20red%20gold%20and%20cream%20tones%2C%20abstract%20geometric%20patterns%20inspired%20by%20Korean%20comics%2C%20soft%20gradient%20atmosphere%2C%20clean%20minimal%20design%2C%20no%20text%2C%20no%20characters%2C%20artistic%20decorative%20background&width=1600&height=900&seq=hanman-hero-bg&orientation=landscape"
        alt="韩漫漫画网 - 无遮韩国免费漫画大全"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
          无遮韩国免费漫画大全
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          韩漫漫画网为您提供海量高品质韩国漫画，免费在线阅读，无需注册。每日更新热门韩漫，
          高清画质丝滑体验，漫画爱好者的理想聚集地。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-lg mx-auto">
          <div className="relative w-full">
            <input
              type="text"
              placeholder="搜索你喜欢的韩漫..."
              className="w-full px-5 py-3.5 rounded-full bg-background-50/95 text-foreground-900 placeholder-foreground-400 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 transition-all duration-200"
            />
            <button className="absolute right-1.5 top-1/2 -translate-y-1/2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer">
              搜索
            </button>
          </div>
        </div>

        <div className="flex items-center justify-center gap-6 mt-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">10,000+</p>
            <p className="text-xs text-background-300 mt-1">漫画资源</p>
          </div>
          <div className="w-px h-10 bg-background-200/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</p>
            <p className="text-xs text-background-300 mt-1">同步韩国</p>
          </div>
          <div className="w-px h-10 bg-background-200/30"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">500万+</p>
            <p className="text-xs text-background-300 mt-1">忠实读者</p>
          </div>
        </div>
      </div>
    </section>
  );
}